import { render, staticRenderFns } from "./MotivosDeAnulacionPagina.vue?vue&type=template&id=7cce2fb3"
import script from "./MotivosDeAnulacionPagina.vue?vue&type=script&lang=js"
export * from "./MotivosDeAnulacionPagina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports